import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Lock, Settings, BarChart3, TrendingUp, ScrollText, Quote, Rocket, CalendarDays, Crown } from 'lucide-react';
import { UrgencyBar } from '../components/UrgencyBar';
import { FAQ } from '../components/FAQ';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { trackPage } from '../utils/analytics';
export function Registro() {
  // Meta Pixel & Analytics
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackPage('/registro');
  }, []);
  // Load GoHighLevel script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://api.leadconnectorhq.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const scrollToForm = () => {
    const formElement = document.getElementById('registro-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="min-h-screen bg-white font-sans text-dark" data-id="element-604" data-mp="36045ymowf019">
      <UrgencyBar data-id="element-605" data-mp="314opro3f4s1o" />

      {/* HERO SECTION - ABOVE THE FOLD */}
      <section className="relative pt-4 pb-8 px-4 md:pt-12 md:pb-20 overflow-hidden" data-id="element-606" data-mp="2dd9ntwfk0cqy">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/2WejS4g1gDYkEogUGNfpCe/susana_sanchez_mentor.png)'
      }} data-id="element-607" data-mp="28ezpjcyj8w14" />
        <div className="absolute inset-0 bg-dark/80" data-id="element-608" data-mp="2ibktduytg13d" />
        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-start" data-id="element-609" data-mp="1umjhfxqry7tc">
          {/* MOBILE: Title first, form second. DESKTOP: Form is on the right */}
          <div className="order-2 lg:order-2 w-full max-w-md mx-auto lg:max-w-none" id="registro-form" data-id="element-610" data-mp="3pr9fwt8ecbo1">
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-xl border-t-4 border-gold-metallic" data-id="element-611" data-mp="3unq6rv6zd44t">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-612" data-mp="3cztuqrxvfqf">
                <Crown className="w-5 h-5 text-gold-metallic" data-id="element-613" data-mp="7byva1egoud4" />
                <h3 className="text-lg md:text-xl font-bold text-center text-dark" data-id="element-614" data-mp="36s579lkrojww">
                  Reserva tu lugar ahora
                </h3>
              </div>
              {/* GoHighLevel Form Widget */}
              <div className="w-full" data-id="element-615" data-mp="3fs0n43p9p339">
                <iframe src="https://api.leadconnectorhq.com/widget/form/aGRSBlVwchDixedJn3DU" style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '4px',
                minHeight: '220px'
              }} id="inline-aGRSBlVwchDixedJn3DU" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Webinar Registration" data-height="220" data-layout-iframe-id="inline-aGRSBlVwchDixedJn3DU" data-form-id="aGRSBlVwchDixedJn3DU" title="Webinar Registration" data-id="element-616" data-mp="3fqz4ne5x9ebi" />
              </div>
              <div className="mt-1 text-center" data-id="element-617" data-mp="dfbva89w8ffp">
                <span className="inline-block bg-gold-light text-gold-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide mb-1" data-id="element-618" data-mp="dgmz283c9n6t">
                  Acceso Exclusivo Gratuito
                </span>
                <p className="text-xs text-gray-500" data-id="element-619" data-mp="27qqjulr648tv">
                  Registro sin costo. Cupo limitado para asegurar la calidad de
                  la sesión.
                </p>
              </div>
            </div>
          </div>

          {/* LEFT CONTENT */}
          <div className="order-1 lg:order-1 flex flex-col justify-center h-full" data-id="element-620" data-mp="25ul8mlaifgfp">
            <motion.div initial="hidden" animate="visible" variants={fadeInUp} data-id="element-621" data-mp="29w6p0gm96cun">
              <div className="inline-flex items-center gap-2 bg-white px-3 py-1.5 rounded-full shadow-sm mb-3 md:mb-6 border border-gold/30" data-id="element-622" data-mp="1w51nta38lci7">
                <CalendarDays className="w-4 h-4 md:w-5 md:h-5 text-gold-metallic" data-id="element-623" data-mp="20xuq7rb8g8r4" />
                <span className="font-semibold text-xs md:text-sm text-gold-dark uppercase tracking-wider" data-id="element-624" data-mp="1m8ouwefin2oi">
                  Webinar gratuito: 28 de mayo, 2026 — 8pm (Hora CDMX)
                </span>
              </div>

              <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-3 lg:mb-6 text-white" data-id="element-625" data-mp="1d7h8atmd3qa9">
                <span className="text-white" style={{
                backgroundImage: 'linear-gradient(transparent 60%, #D6006C 60%)',
                boxDecorationBreak: 'clone',
                WebkitBoxDecorationBreak: 'clone' as any
              }} data-id="element-626" data-mp="yjqnluhdra8f">
                  Terrenos que Pagan:
                </span>{' '}
                El Modelo que está{' '}
                <span className="text-gold-metallic" data-id="element-627" data-mp="1hh9x0z7r2uvd">Transformando</span> las
                Inversiones en México
              </h1>

              {/* Desktop only: show paragraph here */}
              <p className="hidden lg:block text-lg lg:text-xl text-gray-300 leading-relaxed mb-8" data-id="element-628" data-mp="1r7ctxahzssyz">
                <strong className="text-white" data-id="element-629" data-mp="1ma359x2fglc7">Susana Sanchez G</strong> revela
                el sistema de "Coparticipación de Cosecha": Una oportunidad de
                inversión patrimonial donde el terreno es tuyo, los expertos
                operan por ti y tú solo recibes las utilidades anuales
                certificadas.
              </p>
            </motion.div>
          </div>

          {/* Mobile only: paragraph after form */}
          <div className="order-3 lg:hidden" data-id="element-630" data-mp="11xjhtjs3j38n">
            <p className="text-base text-gray-300 leading-relaxed" data-id="element-631" data-mp="11wq767q0ntl8">
              <strong className="text-white" data-id="element-632" data-mp="16orrmgxc8qmc">Susana Sanchez G</strong> revela el
              sistema de "Coparticipación de Cosecha": Una oportunidad de
              inversión patrimonial donde el terreno es tuyo, los expertos
              operan por ti y tú solo recibes las utilidades anuales
              certificadas.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 1: EL GANCHO */}
      <section className="py-20 bg-dark text-white px-4" data-id="element-633" data-mp="1pm2ppy78he07">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-4xl mx-auto text-center" data-id="element-634" data-mp="3ncvlsmf9mtua">
          <div className="w-16 h-16 bg-gold-metallic/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-635" data-mp="3jwj0v0izdlh3">
            <Lock className="w-8 h-8 text-gold-light" data-id="element-636" data-mp="3f24z8gdq6i3z" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-2" data-id="element-637" data-mp="3a5xzj5bxa2uh">
            La Trampa del Sueldo y del Profesional Independiente
          </h2>
          <div className="w-16 h-1 bg-gold-metallic mx-auto mb-8 rounded-full" data-id="element-638" data-mp="6o62vdmucupy"></div>
          <div className="space-y-6 text-lg text-gray-300 leading-relaxed text-left md:text-center" data-id="element-639" data-mp="1pbmeiccji90">
            <p data-id="element-640" data-mp="3tt41l9nywaf4">
              Muchos profesionales o Profesionales Independientes están
              atrapados en una "jaula de oro": tienen buenos ingresos, pero si
              dejan de trabajar hoy, el flujo se detiene mañana. Depender de una
              sola fuente de ingresos —o de una jubilación estatal insuficiente—
              es el mayor riesgo financiero de 2026.
            </p>
            <p data-id="element-641" data-mp="hbr3za0e9xfm">
              La verdadera libertad no es tener un gran ahorro en el banco que
              la inflación devora cada mes; la verdadera libertad es poseer{' '}
              <strong className="text-gold-light" data-id="element-642" data-mp="lb88a0434oj7">
                Sistemas de Producción
              </strong>
              . Este 28 de mayo a las 8pm (Hora CDMX), en mi Webinar gratuito,
              te enseñaré cómo adquirir una "unidad de negocio" física que
              genera dividendos constantes, permitiéndote construir un sueldo
              paralelo que no dependa de tu tiempo.
            </p>
          </div>
        </motion.div>
      </section>

      {/* SECCIÓN 2: LA TESIS DE INVERSIÓN */}
      <section className="py-24 bg-lightgray px-4" data-id="element-643" data-mp="qal61fwhvg0k">
        <div className="max-w-7xl mx-auto" data-id="element-644" data-mp="vah1gqr4lz4i">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-center mb-16" data-id="element-645" data-mp="v95vqle4ehar">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-2 text-dark" data-id="element-646" data-mp="38hf90nso2unz">
              Lo que descubrirás en este entrenamiento
            </h2>
            <div className="w-16 h-1 bg-gold-metallic mx-auto mb-4 rounded-full" data-id="element-647" data-mp="33hb1vodnfcaf"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-648" data-mp="3hcmw7unw70qt">
              Susana Sanchez G desglosará el modelo que los inversionistas
              inmobiliarios tradicionales están ignorando:
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-649" data-mp="2kkt1kikqi42k">
            {[{
            icon: <Settings className="w-8 h-8 text-gold-metallic" data-id="element-650" data-mp="2ykawlfomidkd" />,
            title: 'Infraestructura de Activos Reales',
            desc: "Cómo pasar de comprar 'lotes baldíos' a ser dueño de parcelas productivas con título de propiedad."
          }, {
            icon: <BarChart3 className="w-8 h-8 text-gold-metallic" data-id="element-651" data-mp="8v8jzmvig0ab" />,
            title: "Ingresos de 'Manos Libres'",
            desc: 'El esquema de operación donde tú pones el capital y un equipo agrícola experto con 35 años de experiencia pone el trabajo, la tecnología y la logística de exportación.'
          }, {
            icon: <TrendingUp className="w-8 h-8 text-gold-metallic" data-id="element-652" data-mp="2mwf4d4zzzl9c" />,
            title: 'ROI Compuesto',
            desc: 'Cómo el flujo de caja de la cosecha (Rentas anuales) combinado con la plusvalía de la tierra genera un rendimiento superior a cualquier renta tradicional.'
          }, {
            icon: <ScrollText className="w-8 h-8 text-gold-metallic" data-id="element-653" data-mp="23zdxfemvvb2r" />,
            title: 'Certeza Jurídica de Grado Inversionista',
            desc: 'El marco legal (Escrituras ante Notario y Contratos de Explotación) que protege tu inversión por las próximas dos décadas.'
          }].map((item, idx) => <motion.div key={idx} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={{
            hidden: {
              opacity: 0,
              y: 20
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                delay: idx * 0.1
              }
            }
          }} className="bg-white p-8 rounded-2xl shadow-sm border border-gold/20 hover:shadow-md hover:border-gold/40 transition-all" data-id="element-654" data-mp="3ucv1h2lc16jv" data-mpi={idx}>
                <div className="w-14 h-14 bg-gold-light rounded-xl flex items-center justify-center mb-6" data-id="element-655" data-mp="165372ack4hhv">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-dark" data-id="element-656" data-mp="2hl9zmoyd5739">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-657" data-mp="2mjbknffcnghd">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 3: PERFIL DE LA ESTRATEGA */}
      <section className="py-24 bg-white px-4" data-id="element-658" data-mp="if8e9vp94w42">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-659" data-mp="iimd4typin6r">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-660" data-mp="wdose7pg1ow8">
            <div className="absolute inset-0 bg-gradient-to-br from-gold-metallic to-gold rounded-3xl transform -rotate-3 scale-105 opacity-20" data-id="element-661" data-mp="dihw92tvzqg0"></div>
            <img src="https://cdn.magicpatterns.com/uploads/4zCA77ccagR9m3aBdgwRMG/Estratega_Susana_Sanchez.jpg" alt="Susana Sanchez G" className="relative z-10 w-full rounded-3xl shadow-xl object-cover aspect-[4/5] ring-4 ring-gold-metallic/30" data-id="element-662" data-mp="3h5qlonwp52x8" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-663" data-mp="1wgwk0xbvzc4i">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6 text-dark" data-id="element-664" data-mp="2adtcf37nl1ni">
              Conoce a tu Mentora
            </h2>
            <div className="mb-8 relative bg-gradient-to-r from-gold-light/50 to-transparent p-6 rounded-xl" data-id="element-665" data-mp="21fr4e3pi58qq">
              <Quote className="absolute top-2 left-2 w-10 h-10 text-gold-metallic/30" data-id="element-666" data-mp="26czpac21bqvo" />
              <p className="text-2xl font-heading italic text-gold-dark relative z-10 pl-4 border-l-4 border-gold-metallic" data-id="element-667" data-mp="pzj82k0nytni">
                "Mi objetivo es que tu capital sea el que trabaje horas extra,
                no tú."
              </p>
            </div>
            <div className="space-y-4 text-lg text-gray-600 leading-relaxed" data-id="element-668" data-mp="1aadbq4oxa9fn">
              <p data-id="element-669" data-mp="15ghgha01n0o6">
                <strong data-id="element-670" data-mp="15fzhi5lzy8ck">Susana Sanchez G</strong> es especialista en Bienes
                Raíces e Inversiones de Flujo.
              </p>
              <p data-id="element-671" data-mp="whx9h63uiffs">
                Se dedica a auditar y seleccionar vehículos financieros que
                ofrezcan el equilibrio perfecto entre Seguridad Patrimonial y
                Maximización de Dividendos.
              </p>
              <p data-id="element-672" data-mp="1o939znnhaf5l">
                Es la arquitecta detrás de cientos de estrategias de jubilación
                anticipada en Latinoamérica.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* SECCIÓN 4: TESTIMONIO */}
      <section className="py-20 bg-agri text-white px-4" data-id="element-673" data-mp="8sl0a68iq7dh">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="max-w-4xl mx-auto text-center" data-id="element-674" data-mp="3sghuao1v2km">
          <Quote className="w-12 h-12 text-gold-metallic mx-auto mb-8" data-id="element-675" data-mp="2ke3ortikvl7y" />
          <p className="text-2xl md:text-3xl font-heading font-medium leading-relaxed mb-8" data-id="element-676" data-mp="2ogi7mdm8ykz8">
            "Analicé FIBRAS y departamentos, pero los números del Crowdfarming
            con Susana superaron todo. Es un activo real que diversifica mi
            portafolio y me da flujo anual sin tener que lidiar con inquilinos o
            reparaciones de edificios."
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-677" data-mp="3377krlj9qa5q">
            <div className="w-12 h-12 bg-gold-metallic/30 rounded-full flex items-center justify-center font-bold text-xl text-gold-light" data-id="element-678" data-mp="385sineb1shr0">
              A
            </div>
            <div className="text-left" data-id="element-679" data-mp="1dr86xr4pfwjr">
              <p className="font-bold text-lg" data-id="element-680" data-mp="1ds9gfr62oazd">Ing. Alberto D.</p>
              <p className="text-white/70 text-sm" data-id="element-681" data-mp="1ht35inv93vtu">
                Director de Operaciones e Inversionista
              </p>
            </div>
          </div>
        </motion.div>
      </section>

      {/* SECCIÓN 5: EL CIERRE (CTA) */}
      <section className="py-24 bg-pitahaya-light px-4 text-center" data-id="element-682" data-mp="2g5pagm9za5c4">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="max-w-3xl mx-auto" data-id="element-683" data-mp="2u4f4tu5exqws">
          <Crown className="w-10 h-10 text-gold-metallic mx-auto mb-4" data-id="element-684" data-mp="33zyysb0f2fiw" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-2 text-dark" data-id="element-685" data-mp="2z1p4e2miniyc">
            Asegura tu lugar en este evento exclusivo
          </h2>
          <div className="w-16 h-1 bg-gold-metallic mx-auto mb-10 rounded-full" data-id="element-686" data-mp="38sjpv4rxueiq"></div>

          <div className="bg-white rounded-2xl p-8 shadow-lg mb-10 border border-gold/20 text-left" data-id="element-687" data-mp="38ummw8rid7wy">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-688" data-mp="3mpyjymt4zah1">
              <div data-id="element-689" data-mp="3huszztjao5vl">
                <p className="text-sm text-gold-dark font-bold uppercase tracking-wider mb-1" data-id="element-690" data-mp="3hr55os60zfft">
                  Cuándo
                </p>
                <p className="font-semibold text-lg" data-id="element-691" data-mp="a98jgppivror">
                  28 de Mayo, 2026 — 8pm (Hora CDMX)
                </p>
              </div>
              <div data-id="element-692" data-mp="3se222wtnkeo8">
                <p className="text-sm text-gold-dark font-bold uppercase tracking-wider mb-1" data-id="element-693" data-mp="3sgo82s0wam4c">
                  Para Quién
                </p>
                <p className="font-semibold" data-id="element-694" data-mp="3io8ue6wmsjp9">
                  Personas interesadas en hacer crecer su capital con activos de
                  flujo.
                </p>
              </div>
              <div data-id="element-695" data-mp="38r42dqg3tu0j">
                <p className="text-sm text-gold-dark font-bold uppercase tracking-wider mb-1" data-id="element-696" data-mp="38rnkp89o2kf3">
                  Acceso Inmediato
                </p>
                <p className="font-semibold" data-id="element-697" data-mp="2zpo2wdqtvcb3">
                  Al registrarte, podrás ingresar al Grupo Exclusivo de
                  WhatsApp.
                </p>
              </div>
            </div>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToForm} className="w-full md:w-auto bg-gradient-to-r from-pitahaya to-pitahaya-dark text-white font-bold py-5 px-8 rounded-xl shadow-xl hover:shadow-2xl transition-all flex items-center justify-center gap-3 text-lg md:text-xl mx-auto ring-2 ring-gold-metallic/40 ring-offset-2" data-id="element-698" data-mp="3k7afkr3g5wnx">
            <Rocket className="w-6 h-6" data-id="element-699" data-mp="2whg3wcuv6e59" />
            ¡QUIERO MI ACCESO AL WEBINAR GRATUITO Y DISEÑAR MI RENTA VITALICIA!
          </motion.button>
          <p className="mt-4 text-sm text-gray-600" data-id="element-700" data-mp="2rimo2ds3ub1x">
            Registro sin costo. Cupo limitado para asegurar la calidad de la
            sesión.
          </p>
        </motion.div>
      </section>

      {/* SECCIÓN 6: FAQ */}
      <section className="py-20 bg-white px-4" data-id="element-701" data-mp="2ij7yrhnoc6j0">
        <div className="max-w-3xl mx-auto" data-id="element-702" data-mp="2djd7ve3wfgxy">
          <h2 className="font-heading text-3xl font-bold mb-10 text-center text-dark" data-id="element-703" data-mp="2dketudmgdnug">
            Preguntas Frecuentes
          </h2>
          <FAQ question="¿Se requiere de mi tiempo para la operación?" answer="Absolutamente no. Este sistema está diseñado para el ejecutivo ocupado; tú eres el dueño legal, pero la gestión agrícola y comercial es 100% delegada." data-id="element-704" data-mp="xyurxboi0zfr" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-dark text-white/60 py-8 text-center text-sm" data-id="element-705" data-mp="aatd5l0q8mrw">
        <p data-id="element-706" data-mp="eb3s3n6hyniw">&copy; 2026 Susana Sanchez G. Todos los derechos reservados.</p>
      </footer>
    </div>;
}